// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: 'AIzaSyD6wnD6ssXpgKwob4rKrSu2abRmuZruQ28',
    authDomain: 'supple-portal-205619.firebaseapp.com',
    databaseURL: 'https://supple-portal-205619.firebaseio.com',
    projectId: 'supple-portal-205619',
    storageBucket: 'supple-portal-205619.appspot.com',
    messagingSenderId: '826752099190',
    appId: '1:826752099190:web:fb2eaae708ba9e74'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
